import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "player"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "cover"
};
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "style"
};
const _hoisted_7 = {
  class: "tags"
};
const _hoisted_8 = {
  class: "time"
};
const _hoisted_9 = {
  class: "controls-container"
};
const _hoisted_10 = {
  class: "controls"
};
const _hoisted_11 = {
  key: 0,
  class: "iconfont icon-play"
};
const _hoisted_12 = {
  key: 1,
  class: "iconfont icon-pause"
};
import { ref, onMounted, watch } from 'vue';
import { showMessageError } from "@/utils/dialog";
import { Close } from "@element-plus/icons-vue";
import { formatTime } from "@/utils/libs";
import { httpGet } from "@/utils/http";
export default {
  __name: 'MusicPlayer',
  props: {
    songs: {
      type: Array,
      required: true,
      default: () => []
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'play'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const audio = ref(null);
    const isPlaying = ref(false);
    const songIndex = ref(0);
    const currentTime = ref(0);
    const duration = ref(100);
    const progressPercent = ref(0);
    const progressBarRef = ref(null);
    const title = ref("");
    const tags = ref("");
    const cover = ref("");

    // eslint-disable-next-line no-undef
    const props = __props;
    // eslint-disable-next-line no-undef
    const emits = __emit;
    watch(() => props.songs, newVal => {
      loadSong(newVal[songIndex.value]);
    });
    const loadSong = song => {
      if (!song) {
        showMessageError("歌曲加载失败");
        return;
      }
      title.value = song.title;
      tags.value = song.tags;
      cover.value = song.cover_url;
      audio.value.src = song.audio_url;
      audio.value.load();
      isPlaying.value = false;
      audio.value.onloadedmetadata = () => {
        duration.value = audio.value.duration;
      };
    };
    const togglePlay = () => {
      if (isPlaying.value) {
        audio.value.pause();
        isPlaying.value = false;
      } else {
        play();
      }
    };
    const play = () => {
      if (isPlaying.value) {
        return;
      }
      audio.value.play();
      isPlaying.value = true;
      if (audio.value.currentTime === 0) {
        emits("play");
        // 增加播放数量
        httpGet("/suno/play", {
          song_id: props.songs[songIndex.value].song_id
        }).then().catch();
      }
    };
    const prevSong = () => {
      songIndex.value = (songIndex.value - 1 + props.songs.length) % props.songs.length;
      loadSong(props.songs[songIndex.value]);
      audio.value.play();
      isPlaying.value = true;
    };
    const nextSong = () => {
      songIndex.value = (songIndex.value + 1) % props.songs.length;
      loadSong(props.songs[songIndex.value]);
      audio.value.play();
      isPlaying.value = true;
    };
    const updateProgress = () => {
      try {
        currentTime.value = audio.value.currentTime;
        progressPercent.value = currentTime.value / duration.value * 100;
      } catch (e) {
        console.error(e.message);
      }
    };
    const setProgress = event => {
      const totalWidth = progressBarRef.value.offsetWidth;
      const clickX = event.offsetX;
      const audioDuration = audio.value.duration;
      audio.value.currentTime = clickX / totalWidth * audioDuration;
    };

    // eslint-disable-next-line no-undef
    __expose({
      play
    });
    onMounted(() => {
      loadSong(props.songs[songIndex.value]);
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_image, {
        src: cover.value,
        fit: "cover"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(title.value), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(tags.value), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "text-lightGray"
      }, " | ", -1)), _createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(_unref(formatTime)(currentTime.value)), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "split"
      }, "/", -1)), _createTextVNode(_toDisplayString(_unref(formatTime)(duration.value)), 1)])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
        onClick: prevSong,
        class: "control-btn"
      }, _cache[3] || (_cache[3] = [_createElementVNode("i", {
        class: "iconfont icon-prev"
      }, null, -1)])), _createElementVNode("button", {
        onClick: togglePlay,
        class: "control-btn"
      }, [!isPlaying.value ? (_openBlock(), _createElementBlock("i", _hoisted_11)) : (_openBlock(), _createElementBlock("i", _hoisted_12))]), _createElementVNode("button", {
        onClick: nextSong,
        class: "control-btn"
      }, _cache[4] || (_cache[4] = [_createElementVNode("i", {
        class: "iconfont icon-next"
      }, null, -1)]))])]), _createElementVNode("div", {
        class: "progress-bar",
        onClick: setProgress,
        ref_key: "progressBarRef",
        ref: progressBarRef
      }, [_createElementVNode("div", {
        class: "progress",
        style: _normalizeStyle({
          width: `${progressPercent.value}%`
        })
      }, null, 4)], 512), _createElementVNode("audio", {
        ref_key: "audio",
        ref: audio,
        onTimeupdate: updateProgress,
        onEnded: nextSong
      }, null, 544), __props.showClose ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "close",
        type: "info",
        icon: _unref(Close),
        circle: "",
        size: "small",
        onClick: _cache[0] || (_cache[0] = $event => emits('close'))
      }, null, 8, ["icon"])) : _createCommentVNode("", true)])]);
    };
  }
};